
namespace Gamification.Gamification {
    export class UtentiProdottiBadgeColumns {
        static columnsKey = 'Gamification.UtentiProdottiBadge';
    }
}